import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/index/index.vue"),
  },
  {
    path: "/searchPage/result",
    name: "result",
    component: () => import("@/views/searchPage/result.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
